import { useEffect, useRef, useState } from "react";

// Adds the `is-visible` class to a `.aaa-fade-up` element when it scrolls
// into view. Returns a ref callback compatible with JSX ref usage.
export const useReveal = (options = {}) => {
  const [node, setNode] = useState(null);

  useEffect(() => {
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15, ...options }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]); // eslint-disable-line react-hooks/exhaustive-deps

  return setNode;
};
